import { render, staticRenderFns } from "./shopLookByAdmin.vue?vue&type=template&id=63470616&scoped=true"
import script from "./shopLookByAdmin.vue?vue&type=script&lang=js"
export * from "./shopLookByAdmin.vue?vue&type=script&lang=js"
import style0 from "./shopLookByAdmin.vue?vue&type=style&index=0&id=63470616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63470616",
  null
  
)

export default component.exports